import { useLayoutEffect } from 'react';

import {
	FormRendererLifecycleStage,
	type LifecycleHandlers,
} from '../../../common/types/lifecycle-handlers';

type FormRenderSuccessProps = {
	lifecycleHandlers: LifecycleHandlers;
};

export const FormRenderSuccess = ({ lifecycleHandlers }: FormRenderSuccessProps) => {
	const formRenderSuccessCallback = lifecycleHandlers[FormRendererLifecycleStage.RENDER_COMPLETE];

	useLayoutEffect(
		() =>
			formRenderSuccessCallback &&
			formRenderSuccessCallback({
				stage: FormRendererLifecycleStage.RENDER_COMPLETE,
			}),
		[formRenderSuccessCallback],
	);

	return null;
};
